import './Drawer.less';
import Pricing from '@/pages/pricing/Pricing';
import { BrowserRouter } from 'react-router-dom';
import { useDrawer } from '@/hooks/DrawerHooks';
import { useEffect } from 'react';
import { getToken } from '@/utils/cookie';

export default function Drawer() {
  const { isOpen } = useDrawer();

  useEffect(() => {
    if (!getToken()) {
      return;
    }
    const drawerMain = document.querySelector('.drawer_main');
    if (isOpen) {
      drawerMain.classList.add('active');
    } else {
      drawerMain.classList.remove('active');
    }
  }, [isOpen]);

  if (!getToken()) {
    return null;
  }

  return (
    <>
      <div className="drawer_main" style={{ opacity: !isOpen && 0 }}>
        <BrowserRouter>
          <Pricing />
        </BrowserRouter>
      </div>
    </>
  );
}
